import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mz3xxxsvnf: FaireBrandEntity = {
  token: "b_mz3xxxsvnf",
  type: "brand",
  name: "Lemonade Shoes",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ba206539b061a2e7b75bb8445099bf063b278abdad91355a6eef4faefe97a57.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/655bc9a6fb42368dc65b1ea348cbd8496597cf85a1311c2167de39c73dd5d8c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0ba206539b061a2e7b75bb8445099bf063b278abdad91355a6eef4faefe97a57.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/655bc9a6fb42368dc65b1ea348cbd8496597cf85a1311c2167de39c73dd5d8c8.jpeg",
  location: "City of Industry, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 70,
  isTopShop: true,
  isInsider: true,
  description:
    "Lemonade Shoes is the premier manufacturer and wholesaler of stylish, high-quality fast-fashion footwear. Based in Southern California, our in-house design studio is dedicated to creating runway and celebrity-inspired shoes that keep you ahead of the trends.\n\nOur mission is simple: democratizing haute couture and making high fashion accessible to all. With new designs and updates released weekly, we are committed to keeping your inventory fresh and on-trend.",
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:38:12.712Z",
    importedBy: "entity-db-cli",
  },
};
